import HTTP from "../../../services/HTTP.js";
// fetch WorkPackages
export const getWorkPackages = async (paramsOptions) => {
  const { page, limit } = paramsOptions || {};
  const res = await HTTP.get("work-packages", {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

export const getWorkPackageById = async (id) => {
  const res = await HTTP.get(`/work-packages/${id}`);
  return res.data;
};
export const getWorkPackageByProjectId = async (projectId) => {
  const res = await HTTP.get(`/work-packages/wpByProjectId/${projectId}`);
  return res.data;
};

// fetch WorkPackages by user id
export const getWorkPackagesByUserId = async (userId) => {
  const res = await HTTP.get(`work-packages/${userId}`);
  return res.data;
};

// fetch wp history by id
export const getWorkPackageHistoryById = async (paramsOptions) => {
  const { page, limit, wpId } = paramsOptions || {};
  const res = await HTTP.get(`work-packages/history/${wpId}`, {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

// add WorkPackage
export const addWorkPackage = async (data) => {
  const res = await HTTP.post("work-packages/add", data);
  return res.data;
};

// update WorkPackage
export const updateWorkPackage = async (data) => {
  const res = await HTTP.put("work-packages/update", data);
  return res.data;
};
// delete WorkPackage
export const deleteWorkPackage = async (id) => {
  const res = await HTTP.delete(`work-packages/delete/${id}`);
  return res.data;
};
